import { DependencyMapContent } from './dependency-map/DependencyMapContent';
import { DependencyMapConfig, DependencyMapConfigProvider } from './dependency-map/dependency-map-config';
import { DependencyLink } from './dependency-map/types';

interface DependencyMapProps {
  links: DependencyLink[];
  /**
   * Per-node self-traffic values (`from === to` in the source data). Rendered
   * via the node tooltip rather than as edges.
   */
  selfLoops?: ReadonlyMap<string, number>;
  /** Per-instance config exposed to descendants via `useDependencyMapConfig`. */
  config?: DependencyMapConfig;
}

const EMPTY_CONFIG: DependencyMapConfig = {};
const EMPTY_SELF_LOOPS: ReadonlyMap<string, number> = new Map();

export const DependencyMap = ({ links, selfLoops = EMPTY_SELF_LOOPS, config = EMPTY_CONFIG }: DependencyMapProps) => (
  <DependencyMapConfigProvider config={config}>
    <DependencyMapContent links={links} selfLoops={selfLoops} />
  </DependencyMapConfigProvider>
);
